module.exports = __webpack_public_path__ + "static/img/kl1300-fcm-sdw360-75bb.8da1f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kl1300-fcm-sdw360-75bb.jpg
// module id = A/zW
// module chunks = 0